<script setup>

const props = defineProps({
  merchant: Object,
  title: {
    type: String,
    default: '',
  },
  fileList: {
    type: Array,
    default: [],
  },
});
const emit = defineEmits(['close']);

const { viteLivePreviewURL } = window.chatwootConfig || {};

function getDocsUrl(fileUrl) {
  if (!fileUrl) {
    return "";
  }
  const decodedUrl = decodeURIComponent(fileUrl);
  const fileName = decodedUrl.substring(decodedUrl.lastIndexOf('/') + 1);
  return fileName;
}
</script>

<template>
  <div class="flex flex-col min-h-[300px] max-h-[500px] overflow-hidden">
    <woot-modal-header :header-title="`${title} (${fileList?.length || 0})`" />

    <!-- 滚动区域，给 header 留 padding -->
    <div class="overflow-y-auto px-8 pt-4 pb-6 grid gap-3">
      <div
        v-for="(fileUrl, index) in fileList"
        :key="index"
        class="bg-gray-50 hover:bg-blue-50 border border-gray-200 rounded-lg p-3 transition-all duration-200 shadow-sm flex items-center space-x-2"
      >
        <!-- 图标 -->
        <span class="text-blue-500 text-xl">📎</span>

        <!-- 超链接 -->
        <a
          :href="(viteLivePreviewURL || '') + fileUrl"
          class="highlight text-blue-700 hover:text-blue-900 hover:underline font-medium truncate"
          target="_blank"
          rel="noopener noreferrer"
        >
          {{ getDocsUrl(fileUrl) }}
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
.highlight {
  color: #409EFF; /* 常见的蓝色高亮 */
  text-decoration: underline; /* 下划线 */
  cursor: pointer; /* 鼠标变为手指 */
}
</style>
